// Generated by CoffeeScript 2.7.0
var NextVertexSettingMixin;

export default NextVertexSettingMixin = {
  props: {
    vertexlist: {
      type: Array
    }
  },
  data: function() {
    var ref;
    return {
      nextVertex: ((ref = this.vertexlist) != null ? ref[0] : void 0) || null
    };
  },
  watch: {
    vertexlist: function(new_value) {
      return this.nextVertex = new_value[0] || null;
    },
    nextVertex: function(new_value) {
      return this.$emit('vertexChange', new_value);
    }
  },
  methods: {
    vertexSelectFunc: function(vertex) {
      if (!vertex) {
        return;
      }
      return this.nextVertex = vertex;
    }
  }
};
